import { styled, Switch as MUISwitch } from '@mui/material'
import useGetSwitchTemplate from '~/src/components/mui-wrappers/styled/toggle/styles/useGetSwitchTemplate'

const Toggle = styled(MUISwitch)(() => useGetSwitchTemplate().getComponentSx())

export default Toggle
